import { render, staticRenderFns } from "./SendPaymentModal.vue?vue&type=template&id=9b71eb30&"
import script from "./SendPaymentModal.vue?vue&type=script&lang=js&"
export * from "./SendPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b71eb30')) {
      api.createRecord('9b71eb30', component.options)
    } else {
      api.reload('9b71eb30', component.options)
    }
    module.hot.accept("./SendPaymentModal.vue?vue&type=template&id=9b71eb30&", function () {
      api.rerender('9b71eb30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/SendPaymentModal.vue"
export default component.exports